/**
 * Created by boris on 19/07/2018.
 */
angular.module('moebiusProadapt').controller('ctrlLists', ['$scope', '$rootScope', '$location', '$http', '$window', '$uibModal', 'list', 'resource',
    function($scope, $rootScope, $location, $http, $window, $uibModal, list, resource) {

        $scope.list = list;
        $scope.resource = resource;

        $scope.pagination = {
            itemsPerPage: 2,
            listLength: $scope.list.length,
            currentPage: 1,
            setPage : function (pageNo) {
                $scope.currentPage = pageNo;
            }
        };

        /**
         * Open a modal displaying all editable field for the current resource
         */
        $scope.openEditModal = function(item)
        {
            var scope = $scope.$new();
            scope.resource = resource;
            scope.item = angular.copy(item, {});
            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/lists/modals/modal-edition-correspondant.html',
                    backdrop: 'static',
                    scope: scope
                });
        };

    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/lists/lists.js